// extracted by mini-css-extract-plugin
export default {"pokelist":"MyPokemonList_pokelist__1Q+U2","head":"MyPokemonList_head__Lj+q6"};